import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { resolveBrandFromHost } from './brand.hostmap';
import { BrandConfig, BrandId } from './brand.types';

@Injectable({ providedIn: 'root' })
export class BrandService {
  private _brandId: BrandId = 'zeva';
  private _config?: BrandConfig;

  private readonly fallback: Record<BrandId, BrandConfig> = {
    zeva: {
      brandId: 'zeva',
      displayName: 'Zeva',
      logoPath: '/assets/brands/zeva/logo.png',
      faviconPath: '/assets/brands/zeva/favicon.svg',
      titleSuffix: ' | Zeva',
      apiBaseUrl: 'https://api-test.zevaglobal.com',
      features: {},
    },
    hail: {
      brandId: 'hail',
      displayName: 'Hail',
      logoPath: '/assets/brands/hail/logo.png',
      faviconPath: '/assets/brands/hail/favicon.svg',
      titleSuffix: ' | Hail',
      apiBaseUrl: 'https://api-test.zevaglobal.com',
      features: {},
    },
  };

  get brandId(): BrandId {
    return this._brandId;
  }

  // ✅ allow "not ready yet"
  get config(): BrandConfig | undefined {
    return this._config;
  }

  async init(): Promise<void> {
    this._brandId = resolveBrandFromHost(window.location.hostname);
    const cfgUrl = `/assets/config/${this._brandId}.json`;

    try {
      this._config = await firstValueFrom(this.http.get<BrandConfig>(cfgUrl));
    } catch (err) {
      console.warn(`[Brand] Failed to load ${cfgUrl}. Using fallback.`, err);
      this._config = this.fallback[this._brandId];
    }

    this.applyBrandToDom();
  }

  private applyBrandToDom(): void {
    document.documentElement.setAttribute('data-brand', this._brandId);

    const themeCssPath = this._config?.themeCssPath;
    if (!themeCssPath) return;

    const id = 'brand-theme-css';
    let link = document.getElementById(id) as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }
    link.href = themeCssPath;
  }

  constructor(private http: HttpClient) {}
}
